<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-03-03 10:49:23
 * @LastEditTime: 2022-04-22 18:25:48
-->
<template>
    <div>
        <el-container class="baimo-scrollbar bm bm-no-seleted" :style="{height: container_height+'px'}">
            <el-aside
                :style="{ width: leftWidth + 'px' }"
                class="bm-aside"
                style="overflow: hidden;"
            >
                <div class="information" style="padding: 0px;">
                    <el-tabs type="border-card">
                        <el-tab-pane label="Main">
                            <el-scrollbar :style="{height: mainHeight, background:'white'}">
                            <blast-res-selector
                                @alignAccession="getAlignAccession"
                                :jobid="$route.params.jobid"
                            ></blast-res-selector>
                            <raac-selector></raac-selector>
                            <SelectedRegion :selectedHeight="selectedHeight"></SelectedRegion>
                            </el-scrollbar>
                        </el-tab-pane>
                        <el-tab-pane label="Structure">
                            <StructureSetting></StructureSetting>
                        </el-tab-pane>
                        <el-tab-pane label="Sequence">
                            <SequenceSetting></SequenceSetting>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-aside>
            <BaimocXHandle @leftWidthChange="getLeftWidthChange" />

            <el-main style="padding: 0px;">
                <multi-structure-view :height="structrueHeight + 'px'" width="100%"></multi-structure-view>
                <BaimocYHandle @heightChange="heightChange" />
                <multi-sequence-view
                    :height="totalHeight - structrueHeight - 120 + 'px'"
                    :width="yhandleWidth + 'px'"
                ></multi-sequence-view>
            </el-main>
            <BaimocRXHandle @rightWidthChange="getRightWidthChange" />
            <el-aside
                :width="rightWidth + 'px'"
                style=" display: blank;padding: 0px;background-color: #ffffff; border-left: 1px solid #cccccc;overflow: hidden;z-index:666;"
            >
                <!--<div style="height: 30px; color: #2F363D; background: #F6F8FA;border-top: 1px solid #E1E4E8;border-bottom: 1px solid #E1E4E8">-->
                <!--<p style="padding: 5px 0px 0px 5px; font-weight: 900">Information</p>-->
                <!--</div>-->
                <div class="information">                    
                    <el-tabs type="border-card">
                        <el-tab-pane label="Main">
                            <blast-hits></blast-hits>
                        </el-tab-pane>
                        <el-tab-pane  v-if="current_db === 'AlphaFold'" label="Model">
                            <AlphaFold></AlphaFold>
                        </el-tab-pane>
                        <el-tab-pane label="Protein">
                            <protein></protein>
                        </el-tab-pane>
                        <el-tab-pane label="Raac">
                            <raac></raac>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-aside>
        </el-container>
        <baimo-footer :accession="accession"></baimo-footer>
    </div>
</template>

<script>
import MultiStructureView from "../../components/structure/MultiStructureView";
import MultiSequenceView from "../../components/sequence/MultiSequenceView";
import RaacSelector from "../../components/selector/RaacSelector";
import SelectedRegion from "../../components/selector/SelectedRegion.vue";
import BlastResSelector from "../../components/selector/BlastResSelector";
import BlastHits from "../../components/information/BlastHits";
import Protein from "../../components/information/Protein";
import Raac from "../../components/information/Raac";
// import ThreeSelector from "../../components/selector/ThreeSelector"
import BaimocYHandle from "../../components/BaimocYHandle";
import BaimocXHandle from "../../components/BaimocXHandle";
import BaimocRXHandle from "../../components/BaimocRXHandle";
import StructureSetting from "../../components/laside/StructureSetting";
import SequenceSetting from "../../components/laside/SequenceSetting";
import AlphaFold from "../../components/information/AlphaFold.vue";
import BaimoFooter from "../../components/BaimoFooter";

import global_ from "../../components/units/Global";

export default {
    name: "ExpBrowser",
    data() {
        return {
            website: global_.website,
            selectedHeight: window.innerHeight - 460 + "px",
            mainHeight: window.innerHeight - 90 + "px",
            container_height: window.innerHeight - 70,
            structrueHeight: window.innerHeight - 355 - 40,
            totalHeight: window.innerHeight - 13,
            winHeight: window.innerHeight - 52 + "px",
            winWidth: window.innerWidth - 50 + "px",
            leftWidth: 320,
            rightWidth: 360,
            yhandleWidth: window.innerWidth - 360 - 360,
            loading: true,
            dialogTableVisible: false,
            accession: "Q01860",
            jobid: "",
            selected_id: "",
            current_protein: {},
            current_db: '',
        };
    },
    watch: {
        '$store.state.current_protein'(res, res1) {
                // console.log("$store.state.current_protein>>>", res)
                if (res['accession'] !== res1['accession'] || this.is_init) {
                    this.current_protein = res;
                    
                }
                if (res['source_db'] !== res1['source_db'] || res['pdb_id'] !== res1['pdb_id'] || res['accession'] !== res1['accession'] ) {
                    this.current_protein = res;
                    this.current_db = this.current_protein['source_db']
                }
            },
    },
    components: {
        MultiStructureView,
        BaimocYHandle,
        MultiSequenceView,
        RaacSelector,
        BlastResSelector,
        BlastHits,
        Protein,
        Raac,
        BaimocXHandle,
        BaimocRXHandle,
        StructureSetting,
        AlphaFold,
        BaimoFooter,
        SequenceSetting,
        SelectedRegion,
    },
    mounted() {
        this.jobid = this.$route.params.jobid;
        this.$store.commit("sequenceMenuMutation", {
            color: [""],
            focus: false,
            leftWidth: this.leftWidth,
            multi: false,
            representation: [""],
        });
        this.$store.commit("structureResizeMutation", this.structrueHeight);
        if(this.$store.state.current_tool !== "MultiFold"){
            this.$store.commit("raacSchemeMutation", ['KR','ANCQGHILMFPQSTVWY','DE']);
            this.$store.commit("raacColorMutation", ['#E77F67', '#546DE5', '#546DE5']);
        }
        this.$store.commit("currentToolMutation", "MultiFold");
        this.current_db = this.$store.state.current_protein['source_db']
    },
    methods: {
        getAlignAccession(val) {
            this.accession = val;
            // console.log(val);
        },
        heightChange(movement) {
            this.structrueHeight -= movement;
            this.$store.commit("structureResizeMutation", this.structrueHeight);
        },
        getLeftWidthChange(movement) {
            this.leftWidth -= movement;
            this.yhandleWidth += movement;
            this.$store.commit("structureResizeMutation", this.leftWidth);
            let sequence_menu = this.$store.state.sequence_menu;
            sequence_menu["leftWidth"] = this.leftWidth;
            this.$store.commit("sequenceMenuMutation", sequence_menu);
        },
        getRightWidthChange(movement) {
            this.rightWidth += movement;
            this.$store.commit("structureResizeMutation", this.rightWidth);
        },
    },
};
</script>

<style>
.baimo-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
}

.information .el-tabs--border-card > .el-tabs__content {
    padding: 0px !important;
}

.sss {
    display: flex;
}

.el-tabs--border-card {
    border: none !important;
    box-shadow: none !important;
}

/*.el-select-dropdown__wrap .el-scrollbar__wrap {*/
/*margin-bottom: 100px !important;*/
/*}*/
/*.el-footer {*/
/*background-color: #B3C0D1;*/
/*color: #333;*/
/*text-align: center;*/
/*line-height: 60px;*/
/*}*/

.el-footer {
    background-color: #b3c0d1;
    color: #333;
    text-align: center;
    line-height: 20px;
}
</style>
